import { render, staticRenderFns } from "./StocksModal.vue?vue&type=template&id=48474cf6&"
import script from "./StocksModal.vue?vue&type=script&lang=js&"
export * from "./StocksModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports